import Vue from "vue";
import apis from "@/config/api.config.js"
import qs from "qs";

import {
    DropdownMenu,
    DropdownItem,
    Dialog
} from 'vant';
import {
    Cell,
    CellGroup
} from 'vant';
import {
    Icon
} from 'vant';
import {
    Search
} from 'vant';
import {
    Toast
} from 'vant';
import {
    Button
} from 'vant';
import { Field } from 'vant';

Vue.use(Field);
Vue.use(Button);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

export default {
    name: "index",
    data() {

        return {
            addStar: null,
            show: true,
            stars: [
                0, 0, 0, 0, 0
            ],
            star_cur: -1,
            progress: [
                0,
                10,
                30,
                50,
                70,
                100
            ],
            userName: "",
            userIndex: 0,
            progress_bar_style: 0,
            // no_cert: true,
        };
    },

    computed: {
        no_cert() {
            return this.star_cur == 4 ? false : true
        },

    },

    watch: {
        'star_cur'(nV, oV) {

            if (nV != oV) {
                if (nV >= 4) {
                    this.getInfomation();
                }
                this.progress_bar_style = this.progress[+nV + 1]

            }
        }
    },

    methods: {
        getInfomation() {
            const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.getInfomation,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.code == 200) {
                        Toast.clear()
                        that.userName = res.data.name;

                        that.userIndex = res.data.rownum;//获取到的值显示
                        // console.log(that.userInfo);


                    }
                    else {
                        that.userName = "张三";

                        that.userIndex = 9999;//显示第几名
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        signup() {
            const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.signup,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.code == 200) { //打卡成功
                        Toast.clear()
                        that.getStar()
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        getStarCount() {
            const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.getGloryCount,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.code == 200) {
                        Toast.clear()
                        that.star_cur = res.data

                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });
        },
        getStar() {
            this.show = false;
            this.star_cur++;
            if (this.star_cur > 4) {
                this.star_cur = 4
            }
        },
        toIndex() {
            this.$router.replace('/')
        },
        toCert() {
            this.$router.push('/certificate')
        }

    },
    created() {
        console.log(this.addStar);

        const that = this;
        that.from = that.$route.query.from;
        that.getStarCount();

        // if(that.$route.from)


    },
    mounted() {
        const that = this;

        // if (that.type == 0) {
        //     that.hasIdentify = true;
        //     that.getQuestions()
        // } else {
        //     that.checkUserId();

        //     that.getIdList();
        // }

    },


    beforeRouteEnter(to, from, next) {
        console.log(to, from);
        if (from.path != '/result') {
            next(vm => {
                vm.addStar = false
            })

        } else {
            next(vm => {
                vm.addStar = true
            })
        }
    }


};